import React, { useState, useEffect, useCallback } from "react";
import { Avatar_02, Avatar_01 , Avatar_16 } from "../../../Routes/ImagePath";
import { Link, useParams } from "react-router-dom";  // Added useParams import here
import ProfileTab from "./ProfileTab";
import moment from "moment";
import Swal from 'sweetalert2';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Cropper from 'react-easy-crop';
import ReactSlider from 'react-slider';
import { Modal, Button } from 'react-bootstrap';
import { getCroppedImg } from './getCroppedImg';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';  // Added axios import here

const Profile = () => {
  const [userData, setUserData] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [isCropping, setIsCropping] = useState(false);
  const [profileImage, setProfileImage] = useState(null);
  const [hover, setHover] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const apiUrl = process.env.REACT_APP_API_URL;
  const token = localStorage.getItem("token");
  const dateFormat = localStorage.getItem("dateFormat") || "MMM DD, YYYY";
  const cdnUrl = process.env.REACT_APP_CDN_URL;

  const { userId } = useParams();

  const updateUserData = (updatedData) => {
    setUserData(updatedData);
  };

  
  const capitalizeFirstChar = (string) => {
    if (!string) return string;
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  useEffect(() => {
    fetchUserData();
  }, [userId]);

  const fetchUserData = async () => {
    try {
      const response = await fetch(`${apiUrl}/employees/list?empid=${userId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.ok) {
        const data = await response.json();
        if (data && data.employees && data.employees.length > 0) {
          const userData = data.employees[0];
          setUserData(userData);
          if (userData.profile_pic) {
            const profileImagePath = `${cdnUrl}/${userData.profile_pic}`;
            checkProfileImage(profileImagePath);
          }
        } else {
          console.error("User data not found");
        }
      } else {
        console.error("Failed to fetch user data");
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  const checkProfileImage = async (profileImagePath) => {
    try {
      const response = await fetch(profileImagePath, { method: 'HEAD' });
      if (response.ok) {
        setProfileImage(profileImagePath);
      } else {
        setProfileImage(null);
      }
    } catch (error) {
      console.error("Error checking profile image:", error);
      setProfileImage(null);
    }
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedImage(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewImage(reader.result);
        setIsCropping(true); // Show cropper modal
      };
      reader.readAsDataURL(file);
    }
  };

  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const handleCropSave = async () => {
    try {
      setIsLoading(true); // Set loading state to true
      const croppedImage = await getCroppedImg(previewImage, croppedAreaPixels);
      const formData = new FormData();
      formData.append('image', croppedImage);
      formData.append('empid', userId); // Include empid in the form data

      const response = await axios.post(`${apiUrl}/users/upload-image`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 200) {
        const { imageUrl, imageFile } = response.data;
        setProfileImage(imageUrl);
        setIsCropping(false); // Hide cropper modal
        toast.success('Image uploaded successfully');
        setIsLoading(false); // Set loading state to true
      } else {
        toast.error('Failed to upload image');
        setIsLoading(false); // Set loading state to true
      }
      } catch (error) {
        console.error("Error occurred:", error);
        setIsLoading(false); // Set loading state to true
        if (error.response && error.response.data) {
          const errorMessage = error.response.data.error || "Unknown error occurred.";
          toast.error(errorMessage, {
            position: "top-right",
          });
        } else {
          toast.error("Network error or server unavailable. Please try again.", {
            position: "top-right",
          });
        }
      }
  };

  const handleCancel = () => {
    setIsCropping(false);
    setPreviewImage(null);
  };

  const handleAppAccessToggle = (status) => {
    const action = status === 1 ? 'enable' : 'disable'; // Determine the action text
    
    Swal.fire({
      title: `Are you sure you want to ${action} mobile app access?`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33'
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await fetch(`${apiUrl}/users/app-access`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({ status, empid: userData.id }), // Include both status and empid

          });
  
          if (response.ok) {
            const message = status === 1 ? 'Mobile app access enabled.' : 'Mobile app access disabled.';
            Swal.fire('Success', message, 'success');
            // Update userData to reflect the new status
            setUserData((prevUserData) => ({
              ...prevUserData,
              app_access: status,
            }));
       
          } else {
            const errorData = await response.json();
            Swal.fire('Error', `Failed to update mobile app access: ${errorData.message}`, 'error');
          }
        } catch (error) {
          Swal.fire('Error', `Failed to complete action: ${error.message}`, 'error');
        }
      }
    });
  };
  
  const handleActionClick = async (action) => {
    Swal.fire({
      title: `Are you sure you want to ${action}?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes'
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          if (action === 'Send Invitation' || action === 'Resend Invitation') {
            const response = await fetch(`${apiUrl}/users/invite-team`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
              },
              body: JSON.stringify({ empid: userData.id }),
            });

            if (response.ok) {
              Swal.fire(
                'Success',
                `Invitation has been successfully sent.`,
                'success'
              );
              setUserData({ ...userData, invitation_status: 1 });
              // Optionally, you could update userData.invitation_status here
            } else {
              const errorData = await response.json();
              Swal.fire('Error', `Failed to send invitation: ${errorData.message}`, 'error');
            }
          } else {
            Swal.fire(
              'Success',
              `Action "${action}" has been completed.`,
              'success'
            );
          }
        } catch (error) {
          Swal.fire('Error', `Failed to complete action: ${error.message}`, 'error');
        }
      }
    });
  };

  if (!userData) {
    return (
      <div id="loader-wrapper-">
        <div className="loader">
          <div className="dot"></div>
          <div className="dot"></div>
          <div className="dot"></div>
          <div className="dot"></div>
          <div className="dot"></div>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <ToastContainer />
          <div className="card mb-0">
            <div className="card-body profile-bg">
              <div className="row">
                <div className="col-md-12">
                  <div className="profile-view">
                    <div className="profile-img-wrap">
                      <div
                        className="profile-img position-relative"
                        onMouseEnter={() => setHover(true)}
                        onMouseLeave={() => setHover(false)}
                        onClick={() => document.getElementById('image').click()}
                        style={{ cursor: 'pointer', width: '120px', height: '120px', borderRadius: '50%', overflow: 'hidden' }}
                      >
                        <img
                          src={previewImage || profileImage || (userData.gender === "male" ? Avatar_01 : Avatar_02)}
                          alt="Profile"
                          className="img-fluid w-100 h-100"
                          style={{ objectFit: 'cover', borderRadius: '50%' }}
                        />
                        {hover && (
                          <div className="profile-img-hover position-absolute top-0 start-0 w-100 h-100 d-flex flex-column align-items-center justify-content-center" style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
                            <i className="fa fa-camera" style={{ fontSize: '24px', color: 'white' }}></i>
                          </div>
                        )}
                        <input
                          type="file"
                          className="form-control d-none"
                          id="image"
                          onChange={handleImageChange}
                        />
                      </div>
                    </div>
                    <div className="profile-basic">
                      <div className="row">
                        <div className="col-md-5">
                          <div className="profile-info-left">
                            <h3 className="user-name m-t-0 mb-0">
                              {userData.name} {userData.lastname}
                            </h3>
                            <h6 className="text-muted">{userData.department_name}</h6>
                            <small className="text-muted">
                              {userData.designation_name}
                            </small>
                            <div className="staff-id">
                              Employee ID : {userData.empcode}
                            </div>
                            <div className="small doj text-muted">
                              Date of Join : {moment(userData.employee_doj).format(dateFormat) || "-"}
                            </div>
                          </div>
                        </div>
                        <div className="col-md-7">
                          <ul className="personal-info">
                            <li>
                              <div className="title">Phone:</div>
                              <div className="text">
                                <Link to={`tel:${userData.mobile}`}>
                                  {userData.mobile}
                                </Link>
                              </div>
                            </li>
                            <li>
                              <div className="title">Email:</div>
                              <div className="text">
                                <Link to={`mailto:${userData.email}`}>
                                  {userData.email}
                                </Link>
                              </div>
                            </li>
                            <li>
                              <div className="title">Birthday:</div>
                              <div className="text">
                                {moment(userData.date_of_birth).isValid() ? moment(userData.date_of_birth).format(dateFormat) : "-"}
                              </div>
                            </li>
                            <li>
                              <div className="title">Address:</div>
                              <div className="text">{userData.present_address}</div>
                            </li>
                            <li>
                              <div className="title">Gender:</div>
                              <div className="text">{capitalizeFirstChar(userData.gender)}</div>
                            </li>
                            <li>
                              <div className="title">Reports to:</div>
                              <div className="text">
                                {userData.reporting_name}
                                <div className="avatar-box">
                                  <div className="avatar avatar-xs">
                                    <img src={Avatar_16} alt="User Image" />
                                  </div>
                                </div>
                                <Link to="profile">
                                  {/*userData.supervisor.name*/}
                                </Link>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="pro-edit">
                      <DropdownButton id="dropdown-basic-button" title="Action" variant="info" className="dropdown-button">
                        <Dropdown.Item
                          onClick={() =>
                            handleAppAccessToggle(
                              userData.app_access === 0 || userData.app_access === null ? 1 : 0
                            )
                          }
                        >
                          {userData.app_access === 0 || userData.app_access === null
                            ? 'Enable Mobile Access'
                            : 'Disable Mobile Access'}
                        </Dropdown.Item>
                        <Dropdown.Item data-bs-toggle="modal" data-bs-target="#exit_info_modal">
                          Initiate Exit
                        </Dropdown.Item>
                        <Dropdown.Item
                          onClick={() => handleActionClick(
                            userData.invitation_status === null || userData.invitation_status === 0
                              ? 'Send Invitation'
                              : 'Resend Invitation'
                          )}
                        >
                          {userData.invitation_status === null || userData.invitation_status === 0
                            ? 'Send Invitation'
                            : userData.invitation_status === 1
                            ? 'Resend Invitation'
                            : 'Access Granted'}
                        </Dropdown.Item>
                      </DropdownButton>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Profile Info Tab */}
          <ProfileTab userData={userData} onUpdateUserData={updateUserData} />

          {/* Bootstrap Modal for Image Cropper */}
          <Modal show={isCropping} onHide={handleCancel} centered size="lg" style={{ width: '50%', left: '25%' }} >
            <Modal.Header closeButton>
              <Modal.Title>Update Profile Pic</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="cropper-container" style={{ position: 'relative', width: '100%', height: '400px' }}>
                <Cropper
                  image={previewImage}
                  crop={crop}
                  zoom={zoom}
                  aspect={1}
                  onCropChange={setCrop}
                  onCropComplete={onCropComplete}
                  onZoomChange={setZoom}
                />
                <ReactSlider
                  className="zoom-slider mt-3"
                  thumbClassName="zoom-slider-thumb"
                  trackClassName="zoom-slider-track"
                  value={zoom}
                  onChange={setZoom}
                  min={1}
                  max={3}
                  step={0.1}
                />
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleCancel}>
                Cancel
              </Button>
              <Button
      variant="primary"
      onClick={handleCropSave}
      disabled={isLoading} // Disable button while loading
      style={{ position: "relative" }} // To position spinner properly if needed
    >
      {isLoading ? (
        <>
          <i
            className="fa fa-spinner fa-spin"
            style={{
              marginRight: "8px", // Space between spinner and text
              fontSize: "16px", // Adjust spinner size
            }}
          ></i>
          Updating...
        </>
      ) : (
        "Update"
      )}
    </Button>
            </Modal.Footer>
          </Modal>

        </div>
      </div>
    </>
  );
};

export default Profile;
